<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            d="M16.3032 4.30319c.2214-.22923.4862-.41206.779-.53785.2928-.12578.6077-.19198.9264-.19475.3187-.00277.6347.05795.9297.17863.2949.12067.5629.29888.7882.52422.2254.22534.4036.49331.5242.78826.1207.29495.1814.61098.1787.92965-.0028.31867-.069.6336-.1948.92641-.1258.29281-.3086.55763-.5378.77903l-.9516.9516-3.3936-3.3936.9516-.9516Zm-2.6484 2.6484L3.59998 17.0064V20.4h3.3936L17.0496 10.3452l-3.3948-3.39361Z"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M18.5 3.99969c-.3979 0-.7795.15807-1.0609.43944l-.7929.79289 2.1218 2.12179.7929-.79289c.2814-.28137.4394-.66298.4394-1.0609 0-.39791-.158-.77952-.4394-1.06089-.2814-.28137-.663-.43944-1.0609-.43944Zm2.4751 3.97544c.6564-.65644 1.0252-1.54676 1.0252-2.47511 0-.92834-.3688-1.81866-1.0252-2.4751-.6564-.65644-1.5468-1.02523-2.4751-1.02523-.9283 0-1.8187.36879-2.4751 1.02523L14.5254 4.5244c-.0002.00017.0002-.00018 0 0-.0002.00017-.0009.00086-.001.00104L2.29289 16.7569C2.10536 16.9445 2 17.1988 2 17.464v3.572c0 .5523.44772 1 1 1h3.5c.26522 0 .51957-.1053.70711-.2929L20.9751 7.97513Zm-3.6213.79289L15.232 6.64624 4 17.8782v2.1578h2.08579L17.3538 8.76802Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
